import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Cid10Dto } from '../../dtos/doencas/cid10-dto';
import { ModalPesquisaService } from '../base-pesquisa/modal-pesquisa.service';
import { Cid10Service } from '../../servicos/cid10.service';
import { GridComponent } from '@syncfusion/ej2-angular-grids';
import { ChangeEventArgs } from '@syncfusion/ej2-angular-inputs';

@Component({
  selector: 'app-cid10-search',
  templateUrl: './cid10-search.component.html',
  styleUrls: ['./cid10-search.component.less'],
  providers: [ModalPesquisaService]
})
export class Cid10SearchComponent implements OnInit {
  toolbar: Object[] = [
    'Search'
  ];
  
  @ViewChild('grid')
  grid!: GridComponent;

  initialPage =  { pageSizes: false, pageCount: 4 };

  @Output()
  registroSelecionado: EventEmitter<Cid10Dto> = new EventEmitter<Cid10Dto>();
  
  registros: Cid10Dto[] | null = null;

  @Input()
  empresaId: number | null = null;

  constructor(private modalServico: ModalPesquisaService, 
    private cid10Service: Cid10Service) { }

  ngOnInit(): void {
    this.atualizar();
  }

  selecionado(registro: Cid10Dto) {
    this.registroSelecionado.next(registro);
  }

  abrirTelaCheia() {
    this.modalServico.abrirTelaCheia();
    this.atualizar();
  }

  fechar() {
    this.modalServico.fechar();
  }

  atualizar() {
    this.cid10Service.listarCids10()
    .subscribe((cids) => {
      this.registros = cids;
    })
  }

  calculatePageSize() {
    let element = this.grid.element.parentElement;

    if (element) {
      let size =  this.grid.calculatePageSizeByParentHeight(element.clientHeight.toString());
      this.grid.pageSettings.pageSize = size;
    }
  }
}
